<div class="bmc-change-password-admin">
  <div *ngIf="!changingPassword" class="bmc-change-password-admin__edition-container bz-color-border--neutral-300 bz-space--stack-m">
    <h5 class="bz-space--stack-m">{{'CHANGE_PASSWORD_ADMIN.TITLE' | translate}}</h5>
    <div class="bmc-change-password-admin__inputs">
      <bzg-password name="password-input" class="bz-space--stack-m" [(ngModel)]="password" [required]="true">
        {{ 'CHANGE_PASSWORD_ADMIN.SET_PASSWORD' | translate }}
        <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
      </bzg-password>
      <bzg-password name="passwordConfirmation" [(ngModel)]="verificationPassword"
        infoText="{{ 'AUTOADMIN.PASSWORD_CASE_SENSITIVE' | translate }}"
        [hasCustomErrors]="verificationPassword !== password">
        {{ 'CHANGE_PASSWORD_ADMIN.CONFIRM_PASSWORD' | translate }}
        <bzg-custom-error>{{ 'AUTOADMIN.PASSWORD_DOESNT_MATCH' | translate }}</bzg-custom-error>
      </bzg-password>
    </div>
  </div>
  <div class="bmc-change-password-admin__buttons" *ngIf="!changingPassword">
    <bzg-button-secondary class="bz-space--inline-m" (click)="cancel()">{{'GLOBAL.CANCEL' | translate}}</bzg-button-secondary>
    <bzg-button-primary [disabled]="isPasswordInvalid()" (click)="changeAdminPassword()">
      {{'CHANGE_PASSWORD_ADMIN.BUTTON_ACTION' | translate}}</bzg-button-primary>
  </div>
  <bzg-loading [size]="'m'" class="bmc-change-password-admin__loading" *ngIf="changingPassword">
    {{'CHANGE_PASSWORD_ADMIN.CHANGING_PASSWORD' | translate}}</bzg-loading>
</div>